'use client';

import React from 'react';
import { Box, Skeleton, TableCell, TableRow } from '@mui/material';

interface ReferralHistorySkeletonProps {
  rows: number;
}

/**
 * ReferralHistorySkeleton
 * Renders a set of shimmer rows to indicate loading state for the referral history table.
 */
export const ReferralHistorySkeleton: React.FC<ReferralHistorySkeletonProps> = ({ rows }) => {
  const renderedSkeletons = Array.from({ length: rows }).map((_, index) => (
    <TableRow key={`skeleton-${index}`}>
      <TableCell sx={{ py: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={100} height={20} />
        </Box>
      </TableCell>
      <TableCell sx={{ py: 2 }}>
        <Skeleton variant="text" width={80} height={20} />
      </TableCell>
      <TableCell sx={{ py: 2 }}>
        <Skeleton variant="rounded" width={60} height={24} sx={{ borderRadius: 10 }} />
      </TableCell>
    </TableRow>
  ));

  return <>{renderedSkeletons}</>;
};
